// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file responses/v1/country_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/country_response.proto.
 */
export const file_responses_v1_country_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CiNyZXNwb25zZXMvdjEvY291bnRyeV9yZXNwb25zZS5wcm90bxIMcmVzcG9uc2VzLnYxIjMKD0NvdW50cnlSZXNwb25zZRIKCgJpZBgBIAEoBBIUCgxjb3VudHJ5X2NvZGUYAiABKAlCfwoQY29tLnJlc3BvbnNlcy52MUIUQ291bnRyeVJlc3BvbnNlUHJvdG9QAVoELi9wYqICA1JYWKoCDFJlc3BvbnNlcy5WMcoCDFJlc3BvbnNlc1xWMeICGFJlc3BvbnNlc1xWMVxHUEJNZXRhZGF0YeoCDVJlc3BvbnNlczo6VjFiBnByb3RvMw'
    );

/**
 * @generated from message responses.v1.CountryResponse
 */
export type CountryResponse = Message<'responses.v1.CountryResponse'> & {
    /**
     * @generated from field: uint64 id = 1;
     */
    id: bigint;

    /**
     * @generated from field: string country_code = 2;
     */
    countryCode: string;
};

/**
 * Describes the message responses.v1.CountryResponse.
 * Use `create(CountryResponseSchema)` to create a new message.
 */
export const CountryResponseSchema: GenMessage<CountryResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_country_response, 0);
